<template>
  <a-modal
    :title="title"
    width="1040px"
    :open="open"
    :bodyStyle="{ maxHeight: '80vh', overflowY: 'auto', padding: '0 24px' }"
    :confirm-loading="loading"
    cancel-text="取消"
    ok-text="确定"
    centered
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <template #footer>
      <div class="modal-footer">
        <a-alert
          v-if="fieldValidationMsg"
          class="footer-error"
          type="error"
          show-icon
          :message="fieldValidationMsg"
        />
        <div class="footer-buttons">
          <a-button @click="handleCancel">取消</a-button>
          <a-button
            type="primary"
            :loading="loading"
            :disabled="!!fieldValidationMsg"
            @click="handleOk"
          >
            确定
          </a-button>
        </div>
      </div>
    </template>
    <a-form
      ref="formRef"
      :model="modelType"
      layout="vertical"
      size="small"
    >
      <a-divider orientation="left">基本信息</a-divider>
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-item
            label="数据模型(app_label.model)"
            name="app_label"
            :rules="rules.app_label"
          >
            <a-select
              v-model:value="selectedModel"
              placeholder="请选择数据模型"
              :options="contentTypes"
              option-filter-prop="label"
              show-search
              allow-clear
              :loading="ctLoading"
              @change="onModelChange"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item
            label="模型名称"
            name="name"
            :rules="rules.name"
          >
            <a-input
              v-model:value="modelType.name"
              placeholder="请填写模型名称"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item
            label="排序"
            name="sorted"
          >
            <a-input-number
              v-model:value="modelType.sorted"
              style="width: 100%"
              :min="0"
              :precision="0"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 数据集级处理函数列表（SyncModelType.process_list，对应 DATASET scope） -->
      <a-divider orientation="left">数据处理（数据集级）</a-divider>
      <div
        v-for="(item, idx) in modelType.process_list"
        :key="idx"
        class="pl-item"
      >
        <a-select
          v-model:value="item.func"
          :options="processFuncOptions.dataset"
          placeholder="选择处理函数"
          option-filter-prop="label"
          show-search
          allow-clear
          style="width: 340px"
        />
        <a-textarea
          v-model:value="item.kwargs_str"
          placeholder='可选，JSON 对象，如 {"key":"val"}'
          :auto-size="{ minRows: 3, maxRows: 8 }"
          style="width: 340px"
          allow-clear
          @update:value="val => onKwargsChange(item, val)"
        />
        <a-button
          danger
          type="link"
          @click="removeProcessItem(modelType.process_list, idx)"
        >
          删除
        </a-button>
      </div>
      <a-button
        type="dashed"
        block
        @click="addProcessItem(modelType.process_list)"
      >
        + 添加数据集级处理函数
      </a-button>

      <!-- 字段配置区（SyncModelField） -->
      <a-divider orientation="left">字段配置</a-divider>
      <div class="field-hint">
        选择数据模型后自动加载其表字段；可增删字段行，并配置每个字段的同步属性与处理函数。
        提交前需满足：至少选择一个「唯一字段」和一个「时间索引」字段，且两者都必须是「导入字段」。
      </div>
      <div
        v-if="fieldRows.length > 0"
        class="import-col-toolbar"
      >
        <span class="import-col-label">导入列：</span>
        <a-button
          size="small"
          @click="setAllImportColumn(true)"
        >
          全选
        </a-button>
        <a-button
          size="small"
          @click="setAllImportColumn(false)"
        >
          全不选
        </a-button>
        <a-button
          size="small"
          @click="invertImportColumn"
        >
          反选
        </a-button>
      </div>
      <a-empty
        v-if="fieldRows.length === 0"
        description="暂无字段，请先选择数据模型或点击新增字段"
      />
      <a-card
        v-for="(row, fidx) in fieldRows"
        :key="row.id || 'new_' + fidx"
        size="small"
        class="field-card"
      >
        <template #title>字段 {{ row.field_name }}</template>
        <!-- <template #extra>
          <a-button
            danger
            type="link"
            size="small"
            @click="removeField(fidx)"
          >
            删除字段
          </a-button>
        </template> -->
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="字段名">
              <span class="field-name">{{ row.field_name }}</span>
              <!-- <a-input
                v-model:value="row.field_name"
                placeholder="字段名"
                allow-clear
                readonly
              /> -->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="显示名">
              <a-input
                v-model:value="row.name"
                placeholder="字段显示名"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <a-checkbox v-model:checked="row.is_unique">唯一字段</a-checkbox>
              <a-checkbox
                v-model:checked="row.is_datetime_index"
                @change="onDatetimeIndexChange($event, row)"
              >
                时间索引
              </a-checkbox>
              <a-checkbox v-model:checked="row.is_import_column">导入列</a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- 字段级处理函数列表（SyncModelField.process_list，对应 FIELD scope） -->
        <div class="pl-subtitle">字段级处理函数</div>
        <div
          v-for="(item, idx) in row.process_list"
          :key="idx"
          class="pl-item"
        >
          <a-select
            v-model:value="item.func"
            :options="processFuncOptions.field"
            placeholder="选择处理函数"
            option-filter-prop="label"
            show-search
            allow-clear
            style="width: 340px"
          />
          <a-textarea
            v-model:value="item.kwargs_str"
            placeholder='可选，JSON 对象，如 {"key":"val"}'
            :auto-size="{ minRows: 1, maxRows: 3 }"
            style="width: 340px"
            allow-clear
            @update:value="val => onKwargsChange(item, val)"
          />
          <a-button
            danger
            type="link"
            @click="removeProcessItem(row.process_list, idx)"
          >
            删除
          </a-button>
        </div>
        <a-button
          type="dashed"
          block
          size="small"
          @click="addProcessItem(row.process_list)"
        >
          + 添加字段级处理函数
        </a-button>
      </a-card>
      <!-- <a-button
        type="primary"
        ghost
        block
        style="margin-top: 12px"
        :disabled="form_type === 'create' && !modelType.app_label"
        @click="addField"
      >
        + 新增字段
      </a-button> -->
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue';
import { computed, onMounted, reactive, ref } from 'vue';
import { event_obj } from 'liyu-pc-base/init-plugin';
import { getApiData } from 'liyu-pc-base/api/api-model';
import { useUserStore } from 'liyu-pc-base/init-plugin';

interface Props {
  title: string;
  record: any;
}
const props = defineProps<Props>();
const emit = defineEmits(['cancel', 'ok']);

const formRef = ref<any>(null);
const loading = ref(false);
const ctLoading = ref(false);
const open = ref(true);
const form_type = ref('create');
const userStore = useUserStore();
const current_org = userStore.currentOrg;

/* 选项数据 */
const contentTypes = ref<any[]>([]); // ContentType 列表 [{value, label}]
const modelFields = ref<any[]>([]); // 当前数据模型的字段名列表 [{value, label}]
const processFuncOptions = ref<{ dataset: any[]; field: any[] }>({ dataset: [], field: [] });

/* 基本信息（SyncModelType） */
const modelType = ref<any>({
  id: undefined,
  name: undefined,
  app_label: undefined, // 应用标签（字符串）
  model: undefined, // 模型名（字符串）
  sorted: 0,
  process_list: [] as any[], // [{func, kwargs_str}]
});

/* 选中的内容类型（下拉值，用于回显；实际保存用 app_label + model 字符串） */
const selectedModel = ref<any>(undefined);

/* 字段行（SyncModelField） */
const fieldRows = ref<any[]>([]);

const rules = reactive<any>({
  name: [{ required: true, message: '请填写模型名称' }],
  app_label: [{ required: true, message: '请选择数据模型' }],
});

/* 字段约束校验（响应式）：
 * 1. 必须至少有一个「唯一字段」；
 * 2. 必须至少有一个「时间索引」字段；
 * 3. 被选为「唯一字段」与「时间索引」的字段，必须是「导入字段」（导入列已勾选）。
 * 不达标时返回提示文案，否则返回 null。 */
const fieldValidationMsg = computed<string | null>(() => {
  const rows: any[] = fieldRows.value;
  if (rows.length === 0) return null; // 尚未加载字段（如未选数据模型），交给其它校验处理
  const uniqueFields = rows.filter(f => f.is_unique);
  const datetimeFields = rows.filter(f => f.is_datetime_index);
  if (uniqueFields.length === 0) return '请至少选择一个「唯一字段」';
  if (uniqueFields.some(f => !f.is_import_column))
    return '「唯一字段」必须是导入字段，请勾选该字段的「导入列」';
  if (datetimeFields.length === 0) return '请至少选择一个「时间索引」字段';
  if (datetimeFields.some(f => !f.is_import_column))
    return '「时间索引」字段必须是导入字段，请勾选该字段的「导入列」';
  return null;
});

/* 兼容 getApiData 可能的返回结构（直接数组 或 {data:[...]}） */
const extractData = (res: any) => {
  if (res && typeof res === 'object' && !Array.isArray(res) && res.data !== undefined)
    return res.data;
  return res;
};
const toList = (res: any): any[] => {
  const d = extractData(res);
  return Array.isArray(d) ? d : [];
};

/* 后端 process_list 是 JSONField，返回 [{func, kwargs}]（kwargs 为对象）。
   直接保留 kwargs 对象作为数据源，仅用 kwargs_str 承载多行文本框的展示文本。 */
const mapProcessList = (pl: any): any[] => {
  if (!Array.isArray(pl)) return [];
  return pl.map((item: any) => {
    const kwargs = item?.kwargs ?? null;
    return {
      func: item?.func || undefined,
      kwargs,
      kwargs_str: kwargs ? JSON.stringify(kwargs, null, 2) : '',
    };
  });
};

/* 将 JSON 文本解析为对象；空串返回 {}；解析失败抛出错误（仅作为兜底校验） */
const parseKwargs = (str: string, label: string): any => {
  if (str === undefined || str === null || String(str).trim() === '') return {};
  try {
    return JSON.parse(str);
  } catch (e) {
    throw new Error(`${label} 的 kwargs 不是合法 JSON: ${(e as Error).message}`);
  }
};

/* 文本框输入时实时把 JSON 文本解析为对象，提交时直接复用，避免提交时再 JSON.parse。
   解析失败（输入中 JSON 尚不完整）则保留上次合法值，由提交时的兜底解析负责校验。 */
const onKwargsChange = (item: any, val: string) => {
  item.kwargs_str = val;
  const text = (val || '').trim();
  if (!text) {
    item.kwargs = null;
    return;
  }
  try {
    item.kwargs = JSON.parse(text);
  } catch {
    /* 暂不完整，等待用户补全 */
  }
};

/* 构建提交用的 process_list：优先复用已解析的 kwargs 对象（@update:value 实时解析），
   否则兜底解析 kwargs_str；空则 {}。常规路径不再做 JSON.parse。 */
const buildProcessList = (list: any[]): any[] => {
  const out: any[] = [];
  for (const item of list || []) {
    if (!item.func) continue;
    let kwargs: any;
    if (item.kwargs && typeof item.kwargs === 'object') {
      kwargs = item.kwargs;
    } else if (item.kwargs_str && String(item.kwargs_str).trim()) {
      kwargs = parseKwargs(item.kwargs_str, item.func);
    } else {
      kwargs = {};
    }
    out.push({ func: item.func, kwargs });
  }
  return out;
};

/* 读取内容类型（数据模型类）列表 */
const loadContentTypes = async () => {
  ctLoading.value = true;
  try {
    const res = await getApiData(
      { org_id: current_org?.id },
      `${props.record.model_app}/get_content_types`,
    );
    contentTypes.value = toList(res);
  } catch (e) {
    contentTypes.value = [];
  } finally {
    ctLoading.value = false;
  }
};

/* 读取处理函数列表（按 scope 分组） */
const loadProcessFuncs = async () => {
  try {
    const res = await getApiData(
      { org_id: current_org?.id },
      `${props.record.model_app}/get_process_funcs`,
    );
    const data = extractData(res) || {};
    processFuncOptions.value = { dataset: data.dataset || [], field: data.field || [] };
  } catch (e) {
    processFuncOptions.value = { dataset: [], field: [] };
  }
};

/* 反射指定 (app_label, model) 对应模型的字段名 */
const loadModelFields = async (app_label: any, model: any) => {
  try {
    const res = await getApiData(
      { app_label, model, org_id: current_org?.id },
      `${props.record.model_app}/get_model_fields`,
    );
    modelFields.value = toList(res);
  } catch (e) {
    modelFields.value = [];
  }
};

/* 编辑：调用公共项目提供的详情接口（<app_flag>/get_<model_name>，即 get_basemodel）
   获取完整的 SyncModelType 记录。不依赖列表行数据 props.record，因为它可能缺失
   process_list 等字段。get_basemodel 返回单条 dict（非列表），按 id 查询（参数名
   为 <model_name>_id，即 sync_model_type_id）。 */
const loadModelTypeDetail = async (id: any) => {
  const res = await getApiData(
    { sync_model_type_id: id, org_id: current_org?.id },
    `${props.record.model_app}/get_sync_model_type`,
  );
  return extractData(res) || {};
};

/* 编辑：加载已保存的字段配置（SyncModelField，公共项目通用列表接口按 model_type_id 过滤），
   返回列表（不直接改 fieldRows，后续由 mergeFieldsWithSaved 与最新模型字段合并） */
const loadSavedFields = async (modelTypeId: any): Promise<any[]> => {
  try {
    const res = await getApiData(
      { model_type_id: modelTypeId, page: 1, page_size: 999, org_id: current_org?.id },
      `${props.record.model_app}/query_sync_model_field_list`,
    );
    return toList(res);
  } catch (e) {
    return [];
  }
};

/* 编辑：以最新模型字段为准（不能多、不能少），按 field_name 与已保存配置合并。
   - 遍历最新模型字段（modelFields），每行对应一个最新字段；
   - 若已保存配置中存在相同 field_name：沿用其配置标志与 process_list，并保留 id（便于后端按更新处理）；
   - 若不存在：使用默认值（id 为空，保存时按新建处理）。
   - 已保存但最新模型中已不存在的字段：丢弃（实现「不能多」）。 */
const mergeFieldsWithSaved = (saved: any[]) => {
  const savedByFieldName = new Map<any, any>();
  (saved || []).forEach((f: any) => {
    if (f.field_name != null) savedByFieldName.set(f.field_name, f);
  });
  fieldRows.value = modelFields.value.map((mf: any) => {
    const fn = mf.value;
    const s = savedByFieldName.get(fn);
    return {
      id: s?.id,
      name: mf.verbose_name || mf.value,
      field_name: fn,
      is_unique: s ? !!s.is_unique : false,
      is_datetime_index: s ? !!s.is_datetime_index : false,
      is_import_column: s ? s.is_import_column !== false : true,
      process_list: s ? mapProcessList(s.process_list) : [],
    };
  });
  normalizeDatetimeIndex();
};

/* 选择数据模型后，加载字段名并按新模型的字段初始化字段行。
   无论是新建还是编辑（编辑时切换了数据模型），都应重建字段行——
   原配置字段属于旧模型，切换后不再适用，需用新模型字段重新生成。 */
const onModelChange = async (val: any) => {
  const opt = contentTypes.value.find((o: any) => o.value === val);
  modelType.value.app_label = opt?.app_label;
  modelType.value.model = opt?.model;
  modelFields.value = [];
  fieldRows.value = [];
  if (!opt?.app_label || !opt?.model) return;
  await loadModelFields(opt.app_label, opt.model);
  fieldRows.value = modelFields.value.map(f => {
    let is_import_column = true;
    if (['id', 'is_active', 'create_time', 'update_time'].includes(f.value)) {
      is_import_column = false;
    }
    return {
      name: f.verbose_name || f.value,
      field_name: f.value,
      is_unique: false,
      is_datetime_index: false,
      is_import_column,
      process_list: [],
    };
  });
};

const addProcessItem = (list: any[]) =>
  list.push({ func: undefined, kwargs: null, kwargs_str: '' });
const removeProcessItem = (list: any[], idx: number) => list.splice(idx, 1);

/* 批量控制「是否为导入列」：全选 / 全不选 / 反选 */
const setAllImportColumn = (val: boolean) => {
  fieldRows.value.forEach((f: any) => {
    f.is_import_column = val;
  });
};
const invertImportColumn = () => {
  fieldRows.value.forEach((f: any) => {
    f.is_import_column = !f.is_import_column;
  });
};

/* 时间索引字段互斥单选：勾选某行时，其余行自动取消勾选 */
const onDatetimeIndexChange = (e: any, row: any) => {
  if (e?.target?.checked) {
    fieldRows.value.forEach((f: any) => {
      if (f !== row) f.is_datetime_index = false;
    });
  }
};

/* 编辑加载后规范化：若有多条时间索引为 true（脏数据），仅保留第一条 */
const normalizeDatetimeIndex = () => {
  let found = false;
  fieldRows.value.forEach((f: any) => {
    if (f.is_datetime_index) {
      if (found) f.is_datetime_index = false;
      else found = true;
    }
  });
};

/* 编辑初始化：先调用详情接口拿完整数据，避免依赖可能缺字段的列表行 */
const initForEdit = async () => {
  const id = props.record?.id;
  if (!id) return;
  const d = await loadModelTypeDetail(id);
  modelType.value = {
    id: d.id,
    name: d.name || '',
    app_label: d.app_label || undefined,
    model: d.model || undefined,
    sorted: d.sorted ?? 0,
    process_list: mapProcessList(d.process_list),
  };
  // 下拉回显：根据 app_label + model 匹配选项
  const matched = contentTypes.value.find(
    (o: any) => o.app_label === modelType.value.app_label && o.model === modelType.value.model,
  );
  selectedModel.value = matched?.value ?? undefined;
  if (modelType.value.app_label && modelType.value.model) {
    // 1) 先查最新模型字段（get_model_fields），保证字段是最新的、与模型一致
    await loadModelFields(modelType.value.app_label, modelType.value.model);
    // 2) 再查已保存的字段配置（SyncModelField），按 field_name 合并进最新字段
    const saved = await loadSavedFields(id);
    mergeFieldsWithSaved(saved);
  }
};

/* 构建字段提交数据 */
const buildFieldPayload = (row: any) => ({
  name: row.name,
  field_name: row.field_name,
  is_unique: !!row.is_unique,
  is_datetime_index: !!row.is_datetime_index,
  is_import_column: !!row.is_import_column,
  process_list: buildProcessList(row.process_list),
});

const handleOk = async () => {
  try {
    await formRef.value.validate();
    if (!modelType.value.name) {
      message.error('请填写模型名称');
      return;
    }
    if (form_type.value === 'create' && (!modelType.value.app_label || !modelType.value.model)) {
      message.error('请选择数据模型');
      return;
    }
    // 字段约束：唯一字段 / 时间索引 必选且须为导入字段
    const fieldMsg = fieldValidationMsg.value;
    if (fieldMsg) {
      message.error(fieldMsg);
      return;
    }
    // 校验数据集级 process_list 的 JSON
    let mtProcessList: any[];
    try {
      mtProcessList = buildProcessList(modelType.value.process_list);
    } catch (e: any) {
      message.error(e.message);
      return;
    }
    const app = props.record.model_app;
    const org_id = current_org?.id;
    loading.value = true;

    // 一站式保存：有 id 走更新，无 id 走创建；字段的增/改/删由后端统一处理
    const field_list: any[] = [];
    for (const row of fieldRows.value) {
      let fp: any;
      try {
        fp = buildFieldPayload(row);
      } catch (e: any) {
        message.error(e.message);
        return;
      }
      if (row.id) fp.id = row.id;
      field_list.push(fp);
    }
    const mtPayload: any = {
      name: modelType.value.name,
      app_label: modelType.value.app_label,
      model: modelType.value.model,
      sorted: Number(modelType.value.sorted) || 0,
      process_list: mtProcessList,
      field_list,
      org_id,
    };
    if (form_type.value === 'edit') mtPayload.id = modelType.value.id;
    await getApiData({ ...mtPayload }, `${app}/save_sync_model_type`);
    message.success('操作成功');
    event_obj()?.emit('refresh');
    emit('ok');
  } catch (error) {
    // 校验失败或接口异常：保持弹窗打开
  } finally {
    loading.value = false;
  }
};
const handleCancel = () => emit('cancel');

onMounted(async () => {
  if (props.record?.form_type) form_type.value = props.record.form_type;
  await Promise.all([loadContentTypes(), loadProcessFuncs()]);
  if (form_type.value === 'edit') await initForEdit();
});
</script>

<style scoped lang="less">
.field-hint {
  color: #999;
  font-size: 12px;
  margin-bottom: 8px;
}
.pl-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.pl-subtitle {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
  font-weight: 500;
  margin: 4px 0 8px;
}
.field-card {
  margin-bottom: 12px;
}
.import-col-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.import-col-label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 13px;
}
.modal-footer {
  display: flex;
  flex-direction: column;
}
.footer-error {
  margin-bottom: 8px;
}
.footer-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.field-name {
  font-weight: 500;
  color: #1890ff;
}
</style>
